module.exports = __webpack_public_path__ + "assets/images/01_eab7a51af75b9225a25a8fd0a0f0d449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-two/exercise-1/01.png
// module id = 223
// module chunks = 0